// extracted by mini-css-extract-plugin
export default {"travellersContainer":"_28ELb","skeleton-progress":"KVvu0"};